import { COLORS } from "@src/constants";

export const defaultTheme = {
  token: {
    borderRadius: 2,
    fontFamily: "RWESansWeb-Regular",
    fontSize: 14,
    colorPrimary: COLORS.BRAND_100,
    colorLink: COLORS.BRAND_100,
    colorTextBase: COLORS.FONT_00,
    colorSuccess: COLORS.SUCCESS,
    colorWarning: COLORS.WARNING,
    colorError: COLORS.ALERT,
    colorTextPlaceholder: COLORS.NAVIGATION_GREY,
  },
  components: {
    Avatar: {
      fontSize: 12,
      containerSize: 30,
      fontFamily: "RWESansWeb-Medium, sans-serif",
    },
    Button: {
      fontFamily: "RWESansWeb-Medium",
      contentFontSize: 16,
      //primary
      primaryShadow: "0",
      colorPrimary: COLORS.GRADIENT_GREEN,
      colorPrimaryHover: COLORS.SEMANTIC_PRIMARY_HOVER,
      colorPrimaryActive: COLORS.SEMANTIC_PRIMARY_ACTIVE,
      // default
      defaultColor: COLORS.BRAND_100,
      defaultBorderColor: COLORS.BRAND_100,
      defaultHoverColor: COLORS.BRAND_100,
      defaultHoverBorderColor: COLORS.BRAND_100,
      defaultHoverBg: COLORS.BRAND_10,
      defaultActiveColor: COLORS.BRAND_100,
      defaultActiveBorderColor: COLORS.BRAND_100,
      defaultActiveBg: COLORS.BRAND_20,
      // danger
      colorErrorHover: COLORS.ALERT_DARK,
      // link
      colorLinkHover: COLORS.BRAND_DARK,
      colorLinkActive: COLORS.BRAND_DARK,
    },
    Card: {
      headerHeight: 48,
      headerBg: COLORS.SAND_20,
      headerFontSize: 18,
      colorTextHeading: COLORS.BRAND_100,
    },
    Checkbox: {
      fontFamily: "RWESansWeb-Medium",
      colorPrimary: COLORS.BRAND_100,
      colorText: COLORS.FONT_00,
      colorTextDisabled: COLORS.DISABLED_GREY,
    },
    Collapse: {
      colorTextHeading: COLORS.FONT_00,
      contentBg: COLORS.WHITE,
      headerBg: COLORS.WHITE,
      contentPadding: 10,
    },
    DatePicker: {
      cellActiveWithRangeBg: COLORS.BRAND_20,
    },
    Form: {
      labelColor: COLORS.FONT_00,
    },
    Input: {
      activeBg: COLORS.SAND_20,
      fontSize: 14,
      controlHeight: 40,
      inputFontSizeSM: 12,
      controlHeightSM: 35,
    },
    Layout: {
      bodyBg: COLORS.WHITE,
      siderBg: COLORS.SAND_20,
    },
    Modal: {
      titleFontSize: 24,
      titleColor: COLORS.BRAND_100,
      marginXS: 16,
    },
    Popover: {
      colorTextHeading: COLORS.DARK,
    },
    Progress: {
      defaultColor: COLORS.ENERGY_GREEN,
    },
    Radio: {
      colorPrimary: COLORS.BRAND_100,
      colorPrimaryHover: COLORS.BRAND_100,
      colorBorder: COLORS.BRAND_100,
      dotSize: 9,
    },
    Select: {
      optionFontSize: 16,
      optionSelectedBg: COLORS.TRANSPARENT,
      controlItemBgActiveHover: COLORS.TRANSPARENT,
    },
    Steps: {
      fontSize: 16,
      colorPrimary: COLORS.GRADIENT_GREEN,
      colorText: COLORS.BRAND_100,
    },
    Table: {
      headerBg: COLORS.ANTD_HEADER_BG,
    },
    Tabs: {
      itemColor: COLORS.BRAND_100,
      titleFontSizeLG: 18,
      fontFamily: "RWESansWeb-Medium",
      cardBg: COLORS.LIGHT_GREY_10,
      cardPadding: "8px 24px",
      colorBorderSecondary: COLORS.BRAND_10,
    },
    Tooltip: {
      colorBgSpotlight: COLORS.DARK,
    },
    Transfer: {
      headerHeight: 42,
    },
    Tree: {
      colorPrimary: COLORS.BRAND_100,
      colorText: COLORS.FONT_01,
      nodeHoverBg: COLORS.TRANSPARENT,
      nodeSelectedBg: COLORS.TRANSPARENT,
      fontFamily: "RWESansWeb-Medium",
    },
  },
};
